import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

import PlatformDetailPage from 'components/common/PlatformDetailPage';
import { NOT_FOUND_ROUTE } from 'components/constants';

import { comparisonHub, comparisonPages } from './data';

export const CompareHub: React.FC = () => <PlatformDetailPage data={comparisonHub.page} />;

export const ComparePlatform: React.FC = () => {
  const { competitor } = useParams<{ competitor: string }>();
  const comparison = comparisonPages.find((item) => item.slug === competitor);

  if (!comparison) return <Redirect to={NOT_FOUND_ROUTE} />;

  return <PlatformDetailPage data={comparison.page} />;
};
